const APP = "/";
export const INCOME = `${APP}income`;
export const PURCHASES = `${APP}purchases`;
export const SETTINGS = `${APP}settings`;

export default {
  /** Basic routes */
  LOGOUT: () => "/logout",
  NOT_FOUND: () => "/not-found",
  PRIVACY_POLICY: () => "/privacy-policy",
  HOW_IT_WORKS: () => "/how-it-works",
  ADULT_PRIVACY_POLICY: () => "/adult-privacy-policy",
  TERMS_OF_USE: () => "/terms-of-use",
  STANDARD_CONTRACT: () => "/standard-contract",
  CONTACT_US: () => "/contact-us",
  ABOUT_US: () => "/about-us",
  COOKIE_POLICY: () => "/cookie-policy",
  SIGN_IN: () => "/sign-in",
  CREATOR_PROFILE: () => "/u/",
  MY_PROFILE: () => "/profile",
  CREATORS: () => "/creators/",
  STREAM: () => "/livestream",
  CONTENT_REQUEST: () => "/content-request",
  CONTENT_REQUEST_COMPLETE_PAYMENT: () => "/content-request/complete-payment",
  CONTENT_REQUEST_COMPLETE_PAYMENT_SUCCESS: () =>
    "/content-request/complete-payment/success",
  CONTENT_REQUEST_TERMS: () => "/content-request/terms",

  /** App routes */
  APP: () => APP,
  SETTINGS: (addBasePath = true) => `${addBasePath ? APP : ""}settings`,
  CONSENT_FORMS: (addBasePath = true) =>
    `${addBasePath ? APP : ""}consent-forms`,
  BECOME_CREATOR: (addBasePath = true) =>
    `${addBasePath ? APP : ""}become-creator`,
  MANUAL_BECOME_CREATOR: (addBasePath = true) =>
    `${addBasePath ? APP : ""}become-creator/manual`,
  FEED: (addBasePath = true) => `${addBasePath ? APP : ""}feed`,
  CHAT: (addBasePath = true) => `${addBasePath ? APP : ""}chat`,
  NOTIFICATIONS: (addBasePath = true) =>
    `${addBasePath ? APP : ""}notifications`,
  PURCHASES: (addBasePath = true) => `${addBasePath ? APP : ""}purchases`,
  INCOME: (addBasePath = true) => `${addBasePath ? APP : ""}income`,
  CREATE_POST: (addBasePath = true) => `${addBasePath ? APP : ""}cp`,
  SCHEDULE_LIVESTREAM: (addBasePath = true) =>
    `${addBasePath ? APP : ""}schedule/livestream`,
  DONATE: (addBasePath = true) => `${addBasePath ? APP : ""}donate`,
  COMPLETE_PAYMENT_LIVESTREAM: (addBasePath = true) =>
    `${addBasePath ? APP : ""}send-tip`,
  PURCHASE_POST: (addBasePath = true) =>
    `${addBasePath ? APP : ""}purchase-post`,
  CREATE_CONTENT_PROPOSAL: (addBasePath = true) =>
    `${addBasePath ? APP : ""}content-proposal`,
  EDIT_CONTENT_PROPOSAL: (addBasePath = true) =>
    `${addBasePath ? APP : ""}content-proposal/edit`,
  PURCHASE_SUBSCRIPTION_BY_POST: (addBasePath = true) =>
    `${addBasePath ? APP : ""}purchase-subscription/post/`,
  PURCHASE_SUBSCRIPTION: (addBasePath = true) =>
    `${addBasePath ? APP : ""}purchase-subscription/`,
  MY_SUBSCRIPTIONS: (addBasePath = true) =>
    `${addBasePath ? APP : ""}subscriptions`,
  ALL_SUBSCRIPTIONS: (addBasePath = true) =>
    `${addBasePath ? APP : ""}subscriptions/`,
  CREATE_SUBSCRIPTION: (addBasePath = true) =>
    `${addBasePath ? APP : ""}create-subscription`,
  EDIT_SUBSCRIPTION: (addBasePath = true) =>
    `${addBasePath ? APP : ""}edit-subscription/`,

  /** Income routes */
  INCOME_DASHBOARD: () => INCOME,
  INCOME_SUBSCRIPTIONS: (addBasePath = true) =>
    `${addBasePath ? INCOME : ""}/subscriptions`,
  INCOME_POSTS: (addBasePath = true) =>
    `${addBasePath ? INCOME : ""}/posts-and-tips`,
  INCOME_PROMOTIONS: (addBasePath = true) =>
    `${addBasePath ? INCOME : ""}/promotions`,
  INCOME_AGENCY: (addBasePath = true) => `${addBasePath ? INCOME : ""}/agency`,
  INCOME_CONTENT_REQUESTS: (addBasePath = true) =>
    `${addBasePath ? INCOME : ""}/content-requests`,

  /** Purchases routes */
  PURCHASES_SUBSCRIPTIONS: (addBasePath = true) =>
    `${addBasePath ? PURCHASES : ""}/subscriptions`,
  PURCHASES_POSTS: (addBasePath = true) =>
    `${addBasePath ? PURCHASES : ""}/posts-and-tips`,

  /** Settings routes */
  SETTINGS_MANAGEMENT: (addBasePath = true) =>
    `${addBasePath ? SETTINGS : ""}/management`,
  SETTINGS_BLOCKED: (addBasePath = true) =>
    `${addBasePath ? SETTINGS : ""}/blocked`,
  SETTINGS_EMAIL_PASSWORD: (addBasePath = true) =>
    `${addBasePath ? SETTINGS : ""}/email-password`,
  SETTINGS_2FA: (addBasePath = true) => `${addBasePath ? SETTINGS : ""}/2fa`,
  SETTINGS_PAYMENT_METHODS: (addBasePath = true) =>
    `${addBasePath ? SETTINGS : ""}/payment-methods`,
  SETTINGS_PAYMENT_METHODS_CHECKOUT_STATUS: (addBasePath = true) =>
    `${addBasePath ? SETTINGS : ""}/payment-methods/checkout-status`,
  SETTINGS_PRIVACY: (addBasePath = true) =>
    `${addBasePath ? SETTINGS : ""}/privacy`,
  SETTINGS_NOTIFICATIONS: (addBasePath = true) =>
    `${addBasePath ? SETTINGS : ""}/notifications`,
  SETTINGS_ACCOUNT_CONTROL: (addBasePath = true) =>
    `${addBasePath ? SETTINGS : ""}/account-control`,
};
